import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { differenceInDays } from 'date-fns'

import server from 'server/serverController2'
import FeedGallerySection from 'components/presenters/feed/gallery/FeedGallerySection'
// import FeedGalleryTop from "components/presenters/feed/gallery/FeedGalleryTop"
import FeedGalleryList from 'components/presenters/feed/gallery/FeedGalleryList'
import BottomModal from 'components/presenters/modal/BottomModal'
import CenterModal from 'components/presenters/modal/CenterModal'
import { getDateByTimezone } from 'utils/utils'

import uniFail from 'images/character/uni_fail.png'
import uniThumbsUp from 'images/character/uni_thumbs_up-239x300.png'
import loadingImg from 'images/icon/yellow_loading-40x40.gif'
import LoadingAnimation from 'components/presenters/common/LoadingAnimation'

const FeedList = ({ params, type }) => {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const history = useHistory()

  const [feedList, setFeedList] = useState([])
  const [lastFeedNumber, setLastFeedNumber] = useState(null)
  //CenterModalState
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)
  const [onModalComplete, setOnModalComplete] = useState(null)
  //LoadingState
  const [isLoading, setIsLoading] = useState(false) // 스크롤을 통한 로딩 여부
  const [isEnd, setIsEnd] = useState(false)

  const [isFetchingChallenge, setIsFetchingChallenge] = useState(true)
  const [isFetchingFirstFeed, setIsFetchingFirstFeed] = useState(false)
  const [hasError, setHasError] = useState(false)

  const [challengeInfo, setChallengeInfo] = useState(null)

  let url = null
  let redirectPath = null
  if (type === 'campaign') {
    url = `campaigns/${params['id']}/feed`
    redirectPath = `campaign/${params['id']}`
  } else if (type === 'group') {
    url = `groups/${params['id']}/feed`
    redirectPath = `group/${params['id']}`
  }
  const currDate = getDateByTimezone('Asia/Seoul')

  const handleWhenIsNotLoggedInModal = () => {
    setCenterModalDataList({ type: 'callback', description: '로그인이 필요해요' })
    setOnModalComplete(() => () => history.push(`/social?redirect_path=${redirectPath}`))
    setCenterModalVisible(true)
  }

  const handleScroll = (e) => {
    if (!isLoading && !isEnd) {
      const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight
      if (bottom) {
        setIsLoading(true)
        server.getRequestData(`${url}?last_pos_no=${lastFeedNumber}`, (res) => {
          if (res['success'] === 0 || res.data.feed.length === 0) {
            setIsEnd(true)
            setIsLoading(false)
            return
          }
          const { feed } = res.data
          setLastFeedNumber(feed[feed.length - 1].length === 0 ? 0 : feed[feed.length - 1]['no'])
          setFeedList((list) => {
            return list.concat(feed)
          })
          setIsLoading(false)
        })
      }
    }
  }

  useEffect(() => {
    if (!userInfo['isLogin']) {
      handleWhenIsNotLoggedInModal()
      return
    }

    const initFetch = async () => {
      try {
        const { data: challengeInfo } = await server.getRequestData(`campaigns/${params.id}`)
        setChallengeInfo(challengeInfo)
      } catch (e) {
        console.log(e)
        setHasError(true)
        return
      } finally {
        setIsFetchingChallenge(false)
      }

      setIsFetchingFirstFeed(true)

      try {
        const {
          data: { feed },
        } = await server.getRequestData(url)

        if (feed.length === 0) {
          setIsEnd(true)
        } else {
          setFeedList(feed)
          setLastFeedNumber(feed[feed.length - 1].length === 0 ? 0 : feed[feed.length - 1]['no'])
        }
      } catch (e) {
        console.log(e)
        setHasError(true)
      } finally {
        setIsFetchingFirstFeed(false)
      }
    }

    initFetch()
  }, [])

  return (
    <>
      <FeedGallerySection onScroll={handleScroll}>
        {/* <FeedGalleryTop /> */}
        {feedList.length > 0 ? (
          <FeedGalleryList
            userInfo={userInfo}
            feedList={feedList}
            onSelect={(feedItem) => {
              history.push(`feed/${feedItem['no']}`)
            }}
          />
        ) : isFetchingChallenge || isFetchingFirstFeed ? (
          <Center>
            <div
              style={{
                width: 'calc(100vw * (40 / 375))',
                height: 'calc(100vw * (40 / 375))',
                position: 'relative',
                top: 'calc(100vw * (-40 / 375))',
              }}
            >
              <LoadingAnimation />
            </div>
          </Center>
        ) : challengeInfo && challengeInfo.start_date && challengeInfo.start_date > currDate ? (
          <Center>
            <BeforeStartContent>
              <CharacterImg src={uniThumbsUp} />
              <InfoText>
                챌린지 시작까지
                <br />
                D-{differenceInDays(new Date(challengeInfo.start_date), new Date(currDate))}
              </InfoText>
            </BeforeStartContent>
          </Center>
        ) : (
          <Center>
            <NoFeedContent>
              <CharacterImg
                src={uniFail}
                style={{ position: 'relative', left: 'calc(100vw * (-10 / 375))' }}
              />
              <InfoText>
                {hasError ? '예기치 못한 문제가 발생했어요.' : '아직 인증사진이 없어요.'}
              </InfoText>
            </NoFeedContent>
          </Center>
        )}
      </FeedGallerySection>
      <BottomModal />
      <CenterModal
        modalVisible={centerModalVisible}
        dataList={centerModalDataList}
        onComplete={onModalComplete}
        onCancel={onModalCancel}
      />
    </>
  )
}

export default FeedList

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BeforeStartContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NoFeedContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CharacterImg = styled.img`
  width: calc(100vw * (83 / 375));
  height: calc(100vw * (100 / 375));
  margin-bottom: calc(100vw * (10 / 375));
`

const InfoText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (24 / 375));
  text-align: center;
  color: #7f7f7f;
  padding-bottom: calc(100vw * (25 / 375));
`
